import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IInformationPanelItem } from './components/information-panel-item/information-panel-item.component';
import { applySubtitleSettings, applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ISubtitleStyleSettings, ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyItemSettings } from '../../shared/utils/item-settings-utils';
import { IItemSettings } from '../../shared/interface/item-settings';

interface IInformationPanelData {
  title: IUProperty<string>;
  subtitle: IUProperty<string>;
  capitalizeTitle?: IUProperty<string[]>;
  items: IUProperty<IInformationPanelItem[]>;

  titleStyleSettingsComposition?: ITitleStyleSettings;
  subtitleStyleSettingsComposition?: ISubtitleStyleSettings;
  itemSettingsComposition?: IItemSettings;
}

@Component({
  selector: 'app-information-panel',
  templateUrl: './information-panel.component.html',
  styleUrls: ['./information-panel.component.less']
})
export class InformationPanelComponent implements AfterViewInit {
  @Input() data: IInformationPanelData;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('subtitleEl', { static: false }) subtitleEl: ElementRef<HTMLElement>;
  @ViewChild('contentEl', { static: false }) contentEl: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    if (this.data && this.data.capitalizeTitle && this.data.capitalizeTitle.value) {
      if (this.data.capitalizeTitle.value[0] && this.titleEl && this.titleEl.nativeElement) {
        this.titleEl.nativeElement.style.textTransform = 'uppercase';
      }

      if (this.data.capitalizeTitle.value[1] && this.subtitleEl && this.subtitleEl.nativeElement) {
        this.subtitleEl.nativeElement.style.textTransform = 'uppercase';
      }
    }

    this.setCustomThemeProperties(this.data);
  }

  private setCustomThemeProperties(d: IInformationPanelData): void {
    if (!d) return;

    applyTitleSettings(d, this.titleEl);
    applyItemSettings(d, this.contentEl);
    applySubtitleSettings(d, this.subtitleEl);
  }
}

